module.exports = __webpack_public_path__ + "f79c76c03be0254baab4d218864b6a94.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/empty_tip.png
// module id = 709
// module chunks = 0